<template>
    <div class="container-fluid-grid">
        <div class="form-row">
            <div class="col-6 col-md-2 form-group">
                <label for="userEditName" class="required">Nome</label>
                <input type="text"
                       id="userEditName"
                       :class="{'is-invalid': errors.name}"
                       class="form-control form-control-sm"
                       v-model="entity.name"/>
                <field-messages :errors="errors.name"/>
            </div>
            <div class="col-6 col-md-3 form-group">
                <label for="userEditLastName" class="required">Sobrenome</label>
                <input type="text"
                       id="userEditLastName"
                       :class="{'is-invalid': errors.last_name}"
                       class="form-control form-control-sm"
                       v-model="entity.last_name"/>
                <field-messages :errors="errors.last_name"/>
            </div>
            <div class="col-6 col-md-3 form-group">
                <label for="userEditEmail" class="required">E-mail</label>
                <input type="email"
                       id="userEditEmail"
                       :disabled="isUserProfileScreen"
                       :class="{'is-invalid': errors.email}"
                       class="form-control form-control-sm"
                       v-model="entity.email"/>
                <field-messages :errors="errors.email"/>
            </div>
            <div class="col-6 col-md-2 form-group">
                <label for="userEditProfile" class="required">Perfil</label>
                <select v-model="entity.profile"
                        id="userEditProfile"
                        :disabled="isUserProfileScreen"
                        :class="{'is-invalid': errors.name}"
                        class="form-control form-control-sm">
                    <option v-for="k in Object.keys(profiles)"
                            :key="k"
                            :value="k">{{profiles[k]}}</option>
                </select>
                <field-messages :errors="errors.profile"/>
            </div>
            <div class="col-12 col-md-2">
                <label for="userEditBirth">Nascimento</label>
                <div class="input-group input-group-sm">
                    <input type="text"
                           id="userEditBirth"
                           :class="{'is-invalid': errors.date_of_birth}"
                           v-model="entity.date_of_birth"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           v-mask="'##/##/####'"
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <svg-icon icon="calendar-alt"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-12 col-md-3 form-group">
                <label for="userEditEmailSecondary">E-mail Secundário</label>
                <input type="email"
                       id="userEditEmailSecondary"
                       :class="{'is-invalid': errors.email_secondary}"
                       class="form-control form-control-sm"
                       v-model="entity.email_secondary"/>
                <field-messages :errors="errors.email_secondary"/>
            </div>
            <div class="col-4 col-md-3 form-group">
                <label for="userEditPhone1">Telefone 1</label>
                <input type="text"
                       id="userEditPhone1"
                       :class="{'is-invalid': errors.phone1}"
                       v-mask="['(##) ####-####', '(##) # ####-####']"
                       class="form-control form-control-sm"
                       v-model="entity.phone1"/>
                <field-messages :errors="errors.phone1"/>
            </div>
            <div class="col-4 col-md-3 form-group">
                <label for="userEditPhone2">Telefone 2</label>
                <input type="text"
                       id="userEditPhone2"
                       :class="{'is-invalid': errors.phone2}"
                       v-mask="['(##) ####-####', '(##) # ####-####']"
                       class="form-control form-control-sm"
                       v-model="entity.phone2"/>
                <field-messages :errors="errors.phone2"/>
            </div>
            <div class="col-4 col-md-3 form-group">
                <label for="userEditPhone3">Telefone 3</label>
                <input type="text"
                       id="userEditPhone3"
                       :class="{'is-invalid': errors.phone3}"
                       v-mask="['(##) ####-####', '(##) # ####-####']"
                       class="form-control form-control-sm"
                       v-model="entity.phone3"/>
                <field-messages :errors="errors.phone3"/>
            </div>
        </div>
        <div class="form-row" v-if="isUserProfileScreen">
            <div class="col-6 col-md-2 form-group">
                <label for="userEditPass1" class="required">Senha Atual</label>
                <input type="password"
                       id="userEditPass1"
                       placeholder="Informe a senha atual"
                       maxlength="78"
                       :class="{'is-invalid': errors.password_digest}"
                       class="form-control form-control-sm"
                       v-model="entity.password_digest"/>
                <field-messages :errors="errors.password_digest"/>
            </div>
            <div class="col-4 col-md-2 form-group">
                <label>Alterar Senha?</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label><input type="checkbox"
                                  v-model="changePassword"
                                  class="checkbox green m"/></label>
                </div>
            </div>
            <div class="col-6 col-md-3 form-group">
                <label for="userEditPass2" :class="{required: changePassword}">Nova Senha</label>
                <input type="password"
                       id="userEditPass2"
                       maxlength="78"
                       placeholder="Informe a nova senha"
                       :disabled="!changePassword"
                       :class="{'is-invalid': errors.new_pass}"
                       class="form-control form-control-sm"
                       v-model="entity.new_pass"/>
                <field-messages :errors="errors.new_pass"/>
            </div>
            <div class="col-6 col-md-3 form-group">
                <label for="userEditPass3" :class="{required: changePassword}">{{$appUtils.isMobile() ? 'Conf. ' : 'Confirmação '}}Nova Senha</label>
                <input type="password"
                       id="userEditPass3"
                       maxlength="78"
                       placeholder="Repita a nova senha"
                       :disabled="!changePassword"
                       :class="{'is-invalid': errors.new_pass_confirm}"
                       class="form-control form-control-sm"
                       v-model="entity.new_pass_confirm"/>
                <field-messages :errors="errors.new_pass_confirm"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex'
    import FieldMessage from "../../components/particles/FieldMessage";
    const {mapGetters, mapActions} = createNamespacedHelpers('users');
    export default {
        name: "GeneralTab",
        components: {FieldMessage},
        props: {
            entity: {
                type: Object,
                default: {}
            },
            errors: {
                type: Object,
                default: {}
            },
            isUserProfileScreen: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                changePassword: false
            }
        },
        methods: {
            ...mapActions(['loadProfiles']),
        },
        computed: {
            ...mapGetters(['profiles'])
        },
        mounted() {
            this.loadProfiles();
        }
    }
</script>
